import { CASES } from './constants';
import moment from 'moment-timezone';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

const defaultDateToday = moment().format('YYYY-MM-DD');
const defaultDateYesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 25 (Deal DRO Changes default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.dealDROChanges, 25);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the dealDROChanges slice.
 *
 * Key state values:
 * - dealDROChanges: Array of deal DRO change objects for the grid
 * - filterForm: Search form field values (timestampStart, timestampEnd)
 * - refreshDealDROChanges: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    dealDROChanges: [],
    filterForm: {
        timestampStart: defaultDateYesterday,
        timestampEnd: defaultDateToday,
    },
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    rangeParam: getInitialPaginationRange(initialItemsPerPage),
    sortParam: ['id', 'ASC'],
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshDealDROChanges: false,
};

export function dealDROChanges(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_DEAL_DRO_CHANGES: {
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.dealDROChanges, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_DEAL_DRO_CHANGES_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_DEAL_DRO_CHANGES: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                initialState,
                ['rangeParam']
            );
        }
        default:
            return state;
    }
}